import '../constants/const.css';
import './css/headerPanel.css';

import { FC, CSSProperties, useState, useEffect } from 'react';
import Button from '../components/buttonBase';
import userIcon from '../image/user_image.png';
import logoutIcon from '../image/logout.png';
import passIcon from '../image/password_change.png';
import { LoginService } from '../logic/loginService';
import { useApi, REQ_API_LOGOUT, JsonResponse } from '../logic/classApi';
import { showConfirmMessage } from '../components/appPane';
import { ENVIRONMENT, PATH_ROOT } from '../constants/const';

interface HeaderPanelProps {
  invokeHandle: (isLogin: boolean) => void;
}

const HeaderPanel: FC<HeaderPanelProps> = ({ invokeHandle: InvokeLogout }) => {
  const { postRequestJson } = useApi();

  const [enviromentName, setEnviromentName] = useState('');
  const [enviromentText, setEnviromentText] = useState('');

  useEffect(() => {
    const enviroment: string = ENVIRONMENT;

    const name = [enviroment === 'LOCAL' ? '-local' : enviroment === 'DEVELOP' ? '-develop' : enviroment === 'STAGING' ? '-staging' : enviroment === 'PRODUCTION' ? '' : '']
      .filter(Boolean)
      .join(' ');

    const text = [
      enviroment === 'LOCAL' ? '（LOCAL環境）' : enviroment === 'DEVELOP' ? '（開発環境）' : enviroment === 'STAGING' ? '（検証環境）' : enviroment === 'PRODUCTION' ? '' : '',
    ]
      .filter(Boolean)
      .join(' ');

    setEnviromentName(name);
    setEnviromentText(text);
  }, []);

  const logout = async () => {
    const confirmResult = await showConfirmMessage('ログアウトしてよろしいでしょうか');
    if (confirmResult) {
      const { payload: response } = await postRequestJson<JsonResponse>(REQ_API_LOGOUT, '');
      console.log(response);
      InvokeLogout(false);
      window.history.pushState({}, '', PATH_ROOT);
      LoginService.removeLoginInfo();
    }
  };

  return (
    <div className={'panel' + enviromentName}>
      <hr className="header-hr"></hr>

      <div className="nav">
        <div className="logo">{'LOGO' + enviromentText}</div>
        <div className="branch">{LoginService.getLoginInfo().branchName}</div>

        <div className="user-menu">
          <Button className="user-button">
            <img className="user-icon" src={userIcon} alt="button" width="40px" height="40px"></img>
          </Button>

          <div className={`userdropdown-menu userdropdown${enviromentName}-menu`}>
            <div className="userdropdown-name">{LoginService.getLoginInfo().userName}</div>
            <Button className="logout-button" onClick={logout}>
              <img className="logout-icon" src={logoutIcon} width="20px" height="20px"></img>
              {'ログアウト'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderPanel;
